module.exports = __webpack_public_path__ + "static/media/iconSettingsActive.06cd6217.svg";